/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { Box } from '@mui/material';
import { type ReactNode, useState } from 'react';
import SystemIssueBanners from '../system-issues/SystemIssueBanners';

interface Props {
  children?: ReactNode;
  disableGutters?: boolean;
  reserveMobileBottomNav?: boolean;
}

const PageContent = ({
  children,
  disableGutters = false,
  reserveMobileBottomNav = true,
}: Readonly<Props>) => {
  const [systemIssueBannerHeight, setSystemIssueBannerHeight] = useState(0);

  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        '--system-issue-banner-height': `${systemIssueBannerHeight}px`,
      }}
    >
      <SystemIssueBanners onHeightChange={setSystemIssueBannerHeight} />
      <Box
        data-testid="page-content-scroll"
        sx={{
          flex: 1,
          minHeight: 0,
          minWidth: 0,
          position: 'relative',
          boxSizing: 'border-box',
          overflow: 'auto',
          // to do: inherently this means the page will always have a gap to the app bar
          // even when it might look better for full height pages to not have a gap
          // for now, this is simpler but could look at improving this in future
          pt: 1,
          px: disableGutters ? 0 : 4,
          pb: reserveMobileBottomNav
            ? { xs: 'calc(72px + env(safe-area-inset-bottom))', sm: 0 }
            : 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default PageContent;
